function DatetimepickerCtrl($scope) {
  'ngInject';
  // ViewModel
  const vm = this;

}

export default {
  name: 'DatetimepickerCtrl',
  fn: DatetimepickerCtrl
};
